import React, { useEffect } from 'react';
import { Box, FormControl, FormControlLabel, InputLabel, MenuItem, Paper, Stack, Typography } from '@mui/material';
import { ProgressButton, WO2Select, WO2ToggleSwitch } from 'src/common/components';
import { clientPortalToggleDefinitions } from '../store/constants';
import { Props } from '../container';

export const ClientPortalSettings = ({
  match,
  afsls,
  afslId,
  setAfslId,
  setting,
  hasUnsavedChanges,
  loadingProgress,
  savingProgress,
  fetchAfsls,
  fetchClientPortalSetting,
  saveClientPortalSetting,
  setClientPortalToggle,
}: Props): JSX.Element => {
  useEffect(() => {
    fetchAfsls();
  }, [fetchAfsls]);

  useEffect(() => {
    setAfslId(!!match.params.afslId ? +match.params.afslId : undefined);
  }, [match.params.afslId]);

  useEffect(() => {
    if (!!afslId) {
      fetchClientPortalSetting({ afslId });
    }
  }, [afslId, fetchClientPortalSetting]);

  const isDisabled = !afslId || loadingProgress.isLoading || savingProgress.isLoading;

  return (
    <>
      <Box style={{ paddingTop: '20px' }}>
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
          <Typography variant="h2">Client portal</Typography>
        </Box>
        <Stack direction="row" width={'100%'}>
          <Box display={'flex'} justifyContent={'space-between'} paddingTop="30px" paddingRight={'10px'} width="70%">
            {afsls.length > 1 && (
              <FormControl variant="outlined" style={{ width: '260px' }}>
                <InputLabel id="afsl-select-label">Afsl</InputLabel>
                <WO2Select
                  labelId="afsl-select-label"
                  id="afsl-select"
                  value={afslId || ''}
                  onChange={(event) => {
                    setAfslId(+`${event.target.value}`);
                  }}
                  label={'Afsl'}
                  style={{ width: '600px' }}
                >
                  {afsls.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </WO2Select>
              </FormControl>
            )}
          </Box>
        </Stack>
      </Box>
      <div style={{ width: '100%', paddingTop: '30px' }}>
        <Typography variant="h3" style={{ paddingBottom: '20px' }}>
          Settings
        </Typography>
        <Paper elevation={3}>
          <Box padding={'20px'}>
            {clientPortalToggleDefinitions.map((definition) => (
              <Box key={definition.key} paddingBottom={'10px'}>
                <FormControlLabel
                  control={
                    <WO2ToggleSwitch
                      data-testid={`${definition.key}Toggle`}
                      checked={setting[definition.key]}
                      disabled={isDisabled}
                      onChange={(_event, checked) => setClientPortalToggle({ key: definition.key, value: checked })}
                    />
                  }
                  label={definition.label}
                />
                <Typography variant="body2" color={'textSecondary'} paddingLeft={'48px'}>
                  {definition.description}
                </Typography>
              </Box>
            ))}
            <Box display={'flex'} justifyContent={'flex-end'} paddingTop={'10px'}>
              <ProgressButton
                data-testid="saveButton"
                variant="contained"
                color="primary"
                progress={savingProgress}
                disabled={isDisabled || !hasUnsavedChanges}
                onClick={() => {
                  if (!!afslId) {
                    saveClientPortalSetting({ ...setting, afslId });
                  }
                }}
              >
                SAVE
              </ProgressButton>
            </Box>
          </Box>
        </Paper>
      </div>
    </>
  );
};
